<template>
  <div class="card">
    <div class="card-item">
      <div class="card-title">
        <i
          :class="[checked === 1 ? 'checked' : '']"
          @click="changeChecked(1)"
        />
        <span>个人投诉：</span>
      </div>
      <div class="card-cont">
        <p>需提供：</p>
        <p>
          1、其他材料：如事件解决协议书，单位证明公函，司法机关证明等（可选）。
        </p>
        <p>2、当事人授权委托书（非本人投诉）。</p>
      </div>
    </div>
    <div class="card-item">
      <div class="card-title">
        <i
          :class="[checked === 2 ? 'checked' : '']"
          @click="changeChecked(2)"
        />
        <span>企业投诉：</span>
      </div>
      <div class="card-cont">
        <p>需提供：</p>
        <p>1、企业法人营业执照。</p>
        <p>
          2、其他材料：如事件解决协议书，单位证明公函，司法机关证明等（可选）。
        </p>
        <p>3、法人代表或企业授权委托书，本人在职证明（非法人代表投诉）。</p>
        <p>注：所有材料必须加盖公章</p>
      </div>
    </div>
    <div class="attach">
      <div class="attach-desc">
        上传附件个数最多支持10个，每个附件不超过5M，仅支持图片（PNG、JPG、JPEG、BMP、GIF）格式的文件
      </div>
      <div class="attach-cont">
        <span>上传附件：</span>
        <hy-upload-multiple
          @remove="remove"
          @uploadChange="uploadChange"
          :reset="reset"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { HyUploadMultiple } from "../../../components/HyUpload";
export default {
  components: {
    HyUploadMultiple
  },
  props: {
    reset: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      checked: 1
    };
  },
  methods: {
    changeChecked(type) {
      if (this.checked === type) return;
      this.checked = type;
      this.$emit("radioChange", type);
    },
    remove(fileArr) {
      this.$emit("attachChange", fileArr);
    },
    uploadChange(fileArr) {
      this.$emit("attachChange", fileArr);
    }
  }
};
</script>
<style lang="scss" scoped>
.card {
  width: 993px;
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;
  border: 1px solid rgba(151, 151, 151, 1);
  padding: 27px 40px 54px;
  box-sizing: border-box;
  margin-top: 52px;
}
.card-item {
  &:nth-child(1) {
    margin-bottom: 34px;
  }
  .card-title {
    display: flex;
    cursor: pointer;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 1);
    margin-bottom: 9px;
    i,
    span {
      display: inline-block;
    }
    i {
      width: 24px;
      height: 24px;
      border-radius: 12px;
      background: rgba(255, 255, 255, 1);
      border: 2px solid rgba(174, 174, 174, 1);
      box-sizing: border-box;
      margin-right: 10px;
    }
    .checked {
      border: 6px solid #4295d2;
    }
  }
  .card-cont {
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(105, 105, 105, 1);
    line-height: 25px;
    padding-left: 34px;
  }
}
.attach {
  margin-top: 34px;

  .attach-desc {
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(105, 105, 105, 1);
    line-height: 25px;
  }
  .attach-cont {
    margin-top: 6px;
    display: flex;
    align-items: flex-start;
    span {
      font-size: 20px;
    }
  }
}
</style>
